import { Link } from 'react-router-dom';
import { Icon } from './icon';
import { t } from '../locales/i18n';
import { ConfirmIcon } from './widgets/confirm-button';
import React from 'react';
import { appSettingsPath, providerMessagePath, queuesPath /*, calendarPath */, queueSettingsPath } from '../navigation';
import styled from 'styled-components';
import { colors } from '@nextinq/ui-toolkit';
import { transparentize } from 'polished';
import { sizes } from '../themes/sizes';
import { RootState } from '../root-reducer';
import { useSelector } from 'react-redux';

const Container = styled.section`
  padding-top: ${sizes.margins.large};
  background-color: ${transparentize(0.1, colors.grey.greyDarker)};
  display: grid;
  grid-auto-rows: max-content;
  min-height: 100vh;
  justify-items: center;
  align-items: flex-start;
  &,
  a,
  a:visited {
    color: ${colors.neutral.white};
    text-align: center;
  }
  a:focus,
  a:hover {
    color: ${colors.light.primary};
  }
`;

const Item = styled.section`
  margin: ${sizes.margins.huge} 0;
  cursor: pointer;
  i {
    font-size: ${sizes.fonts.huge};
  }
  > a {
    display: grid;
    align-items: center;
    justify-items: center;
    grid-gap: ${sizes.margins.normal};
  }
`;

export interface DrawerPanelProps {
  uuidFromUrl: string;
  onClick: () => void;
  closeBooth: () => void;
}

export function DrawerPanel(props: DrawerPanelProps) {
  const { uuidFromUrl, onClick } = props;
  const { boothStatus, connectedQueues } = useSelector((s: RootState) => s.queues);
  return (
    <Container onClick={onClick}>
      <Item>
        <Link to={queuesPath(uuidFromUrl)}>
          <Icon name="list" />
          <span>{t('pages.queues')}</span>
        </Link>
      </Item>

      {connectedQueues.map((q) => (
        <Item key={q.id}>
          <Link to={queueSettingsPath(uuidFromUrl, q.id)}>
            <i className="icons">
              <Icon name="list" />
              <Icon corner name="setting" />
            </i>
            <span>{t('pages.queueSettings', q)}</span>
          </Link>
        </Item>
      ))}

      {/* <Item>
        <Link to={calendarPath(uuidFromUrl)}>
          <Icon name="calendar" />
          <span>{t('pages.calendar')}</span>
        </Link>
      </Item> */}
      <Item>
        <Link to={providerMessagePath(uuidFromUrl)}>
          <Icon name="announcement" />
          <span>{t('pages.providerMessage')}</span>
        </Link>
      </Item>
      {boothStatus === 'open' && (
        <Item>
          <ConfirmIcon
            primary
            iconName="close"
            title={t('dialog.closeBooth.title')}
            label={t('dialog.closeBooth.title')}
            onConfirm={props.closeBooth}
          />
        </Item>
      )}
      <Item>
        <Link to={appSettingsPath(uuidFromUrl)}>
          <Icon name="setting" />
          <span>{t('pages.settings')}</span>
        </Link>
      </Item>
    </Container>
  );
}
